module.exports = __webpack_public_path__ + "static/media/batteryoff.7654db88.svg";